import { useRef, useEffect } from "react";
import { BRAND, BLOOMERANG_CONFIG } from "../constants";
import BloomerangPaymentElement from "./BloomerangPaymentElement.jsx";

export default function PaymentForm({ processing, tierPrice, cardError, paymentAdapter, adapter, coverFees, onCoverFeesChange }) {
  var mockContainerRef = useRef(null);

  // Mount mock adapter's payment element into the ref div
  useEffect(function () {
    if (paymentAdapter === "mock" && adapter && mockContainerRef.current) {
      adapter.mountPaymentElement(mockContainerRef.current);
    }
  }, [paymentAdapter, adapter]);

  // Calculate fee amount using BLOOMERANG_CONFIG rates
  var feeAmount = 0;
  if (coverFees && tierPrice) {
    feeAmount = Math.round(
      ((tierPrice + BLOOMERANG_CONFIG.transactionFee) / (1 - BLOOMERANG_CONFIG.transactionFeeRate) - tierPrice) * 100
    ) / 100;
  }

  var totalAmount = tierPrice + (coverFees ? feeAmount : 0);

  return (
    <div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", margin: "0 0 4px", color: "#1A1A1A", fontWeight: 800, display: "flex", alignItems: "center", gap: "8px" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={BRAND.primary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        Secure Donation
      </h2>
      <p style={{ fontSize: "13px", color: "#888", margin: "0 0 20px" }}>
        Your payment information is encrypted and secure.
      </p>

      {/* Payment element — rendered by adapter based on mode */}
      <div style={{
        opacity: processing ? 0.6 : 1,
        transition: "opacity 0.2s",
      }}>
        {paymentAdapter === "bloomerang" && adapter && (
          <BloomerangPaymentElement adapter={adapter} />
        )}
        {paymentAdapter === "mock" && (
          <div ref={mockContainerRef} />
        )}
        {!paymentAdapter && (
          /* Fallback: show a placeholder if no payment mode is set */
          <div style={{
            background: "#FAFAF7",
            border: "1.5px solid #DDD",
            borderRadius: "8px",
            padding: "20px",
            textAlign: "center",
            color: "#888",
            fontSize: "13px",
          }}>
            Payment form not configured.
          </div>
        )}
      </div>

      {cardError && (
        <p style={{ color: "#D32F2F", fontSize: "13px", margin: "8px 0 0", textAlign: "center" }}>
          {cardError}
        </p>
      )}

      {/* True Impact fee coverage checkbox */}
      <div style={{ marginTop: "16px" }}>
        <label style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          cursor: "pointer",
          fontSize: "13px",
          color: "#444",
          lineHeight: "1.4",
        }}>
          <input
            type="checkbox"
            checked={coverFees || false}
            onChange={function (e) {
              if (onCoverFeesChange) onCoverFeesChange(e.target.checked);
            }}
            style={{
              marginTop: "2px",
              accentColor: BRAND.primary,
              width: "16px",
              height: "16px",
              flexShrink: 0,
            }}
          />
          <span>
            I'd like to cover the processing fees
            {coverFees && tierPrice > 0 && (
              <span style={{ color: BRAND.primary, fontWeight: 600 }}>
                {" "}(+${feeAmount.toFixed(2)})
              </span>
            )}
          </span>
        </label>
        {coverFees && tierPrice > 0 && (
          <p style={{ fontSize: "12px", color: "#888", margin: "6px 0 0 24px" }}>
            Total: ${totalAmount.toFixed(2)}
          </p>
        )}
      </div>

      <div style={{ marginTop: "14px", display: "flex", alignItems: "center", gap: "6px", justifyContent: "center" }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#BBB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        <span style={{ fontSize: "11px", color: "#BBB" }}>
          {paymentAdapter === "bloomerang"
            ? "Powered by Bloomerang \u2014 256-bit SSL encryption"
            : paymentAdapter === "mock"
              ? "Mock payment mode \u2014 no charges will be made"
              : "Secure payment \u2014 256-bit SSL encryption"
          }
        </span>
      </div>
    </div>
  );
}
